export default __webpack_public_path__ + "static/media/medaille-bdo-cap-conception.4cf0faaa.png";